// extracted by mini-css-extract-plugin
export default {"container":"BetListFilters_container__Tlvq-","filters":"BetListFilters_filters__wB1kS"};